import {
  Modal,
  Typography,
  TextField,
  Box,
  InputAdornment,
  Button,
  Divider,
  Autocomplete,
  Container,
} from '@common/components'
import { useTranslation } from 'react-i18next'
import SearchIcon from '@mui/icons-material/Search'
import {
  CreateWeblinkRequest,
  UpdateWeblinkRequest,
  useWeblinksCreateWeblinkMutation,
  useWeblinksUpdateWeblinksMutation,
} from '@app/services/auto-generated/weblinks'
import { SubmitHandler, useForm } from '@lib/form'
import { yupResolver } from '@hookform/resolvers/yup'
import { weblinkSchema } from '@common/utils/validations/weblinks.validations'

const WeblinkModal = (props) => {
  const { modify, open, handleClose, weblinkId, weblinkTitle, weblinkLink, weblinkTags } = props
  const { t } = useTranslation()
  const [addWeblink, { isLoading, isSuccess, isError }] = useWeblinksCreateWeblinkMutation()
  const { handleSubmit, control, reset } = useForm<CreateWeblinkRequest>({
    defaultValues: {
      link: '',
      title: '',
      shared_with: [],
      tags: [],
    },
  })
  const onSubmit: SubmitHandler<CreateWeblinkRequest> = async (formState) => {
    try {
      await addWeblink({ createWeblinkRequest: formState }).unwrap()
      reset()
      handleClose()
    } catch (err) {}
  }

  const [updateWeblink, { isSuccess: isSuccessUpdate, isLoading: isLoadingUpdate }] =
    useWeblinksUpdateWeblinksMutation()
  const { handleSubmit: handleUpdateSubmit, control: updateControl } =
    useForm<UpdateWeblinkRequest>({
      defaultValues: {
        link: weblinkLink,
        title: weblinkTitle,
        shared_with: [],
        tags: weblinkTags,
      },
      resolver: yupResolver(weblinkSchema),
    })
  const onUpdateSubmit: SubmitHandler<UpdateWeblinkRequest> = async (formState) => {
    try {
      await updateWeblink({
        weblinkId: weblinkId,
        updateWeblinkRequest: formState,
      }).unwrap()
      handleClose()
    } catch (err) {}
  }

  return modify ? (
    <Modal
      open={open}
      paperProps={{
        sx: { padding: '20px' },
      }}
      onClose={handleClose}
    >
      <Container component={'form'} onSubmit={handleUpdateSubmit(onUpdateSubmit)}>
        <Typography sx={{ fontWeight: 600, fontSize: '18px', mt: 2 }}>
          {t('weblink-modal.edit-ressource', 'Edit a ressource')}
        </Typography>
        <Typography sx={{ fontWeight: 400, fontSize: '14px' }}>
          {t('weblink-modal.share', 'Share with your students anything you want.')}
        </Typography>
        <Typography sx={{ fontWeight: 500, fontSize: '14px', mt: 2 }}>
          {t('weblink-modal.title', 'Title')}
        </Typography>
        <TextField fullWidth size='small' control={updateControl} name='title'></TextField>
        <Typography sx={{ fontWeight: 500, fontSize: '14px', mt: 2 }}>
          {t('weblink-modal.website', 'Website')}
        </Typography>
        <TextField
          control={updateControl}
          name='link'
          placeholder='www.example.com'
          fullWidth
          size='small'
          // InputProps={{
          //   startAdornment: (
          //     <InputAdornment position="start">
          //       <Typography>https://</Typography>
          //       <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          //     </InputAdornment>
          //   ),
          // }}
        ></TextField>
        <Typography sx={{ fontWeight: 500, fontSize: '14px', mt: 2 }}>
          {t('weblink-modal.tags', 'Tags')}
        </Typography>
        <Autocomplete
          name='tags'
          multiple
          options={[]}
          renderInput={(params) => <TextField {...params} placeholder='Add a tag' />}
          freeSolo={true}
          size='small'
          control={updateControl}
        />
        {/* <Typography sx={{ fontWeight: 500, fontSize: "14px", mt: 2 }}>
          {t("weblink-modal.share-with", "Share With")}
        </Typography>
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          fullWidth
          size="small"
        /> */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Button
            variant='outlined'
            sx={{ width: '150px', borderRadius: '8px' }}
            onClick={handleClose}
          >
            {t('weblink-modal.cancel', 'cancel')}
          </Button>
          <Button
            variant='contained'
            sx={{ width: '150px', borderRadius: '8px' }}
            type='submit'
            loading={isLoadingUpdate}
          >
            {t('weblink-modal.save', 'save')}
          </Button>
        </Box>
      </Container>
    </Modal>
  ) : (
    <Modal
      open={open}
      paperProps={{
        sx: { padding: '20px' },
      }}
      onClose={handleClose}
    >
      <Container component={'form'} onSubmit={handleSubmit(onSubmit)}>
        <Typography sx={{ fontWeight: 600, fontSize: '18px', mt: 2 }}>
          {t('weblink-modal.add-ressource', 'Add a ressource')}
        </Typography>
        <Typography sx={{ fontWeight: 400, fontSize: '14px' }}>
          {t('weblink-modal.share', 'Share with your students anything you want.')}
        </Typography>
        <Typography sx={{ fontWeight: 500, fontSize: '14px', mt: 2 }}>
          {t('weblink-modal.title', 'Title')}
        </Typography>
        <TextField fullWidth size='small' name='title' control={control}></TextField>
        <Typography sx={{ fontWeight: 500, fontSize: '14px', mt: 2 }}>
          {t('weblink-modal.website', 'Website')}
        </Typography>
        <TextField
          name='link'
          control={control}
          placeholder='www.example.com'
          fullWidth
          size='small'
          // InputProps={{
          //   startAdornment: (
          //     <InputAdornment position="start">
          //       <Typography>https://</Typography>
          //       <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          //     </InputAdornment>
          //   ),
          // }}
        ></TextField>
        <Typography sx={{ fontWeight: 500, fontSize: '14px', mt: 2 }}>
          {t('weblink-modal.tags', 'Tags')}
        </Typography>
        <Autocomplete
          name='tags'
          multiple
          options={[]}
          renderInput={(params) => <TextField {...params} placeholder='Add a tag' />}
          freeSolo={true}
          size='small'
          control={control}
        />
        {/* <Typography sx={{ fontWeight: 500, fontSize: "14px", mt: 2 }}>
          {t("weblink-modal.share-with", "Share With")}
        </Typography>
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          fullWidth
          size="small"
        /> */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Button
            variant='outlined'
            sx={{ width: '150px', borderRadius: '8px' }}
            onClick={() => {
              reset()
              handleClose()
            }}
          >
            {t('weblink-modal.cancel', 'cancel')}
          </Button>
          <Button
            variant='contained'
            sx={{ width: '150px', borderRadius: '8px' }}
            loading={isLoading}
            type='submit'
          >
            {t('weblink-modal.add', 'add')}
          </Button>
        </Box>
      </Container>
    </Modal>
  )
}

export default WeblinkModal
